module.exports = __webpack_public_path__ + "static/kaja-kujawa-medinvest-0cbf4964a1dfefa2e41d741f174496f4.jpg";